import { inject, InjectionToken } from "@angular/core";
import { NewsSettingRoutePaths } from "@app/shared/news/news-setting-route-paths";
import { SideNavService } from "@shared-core/components/side-nav/services/side-nav.service";
import { COMMON_GUARD_OPTIONS } from "@shared/auth/constants/permissions.constant";

export const NEWS_SIDENAV_LINK = new InjectionToken<void>("SETTING_SUB_LINK", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.addSubMenuItems("setting", [
      {
        id: "settings-news",
        label: "SETTINGS_NEWS.TITLE",
        icon: "rss",
        items: [
          {
            id: "tag",
            label: "SETTINGS_NEWS.ITEMS.ARTICLE_TAG",
            routerLink: NewsSettingRoutePaths.tag,
            permissions: COMMON_GUARD_OPTIONS.ARTICLE_TAG.VIEW.permissions,
          },
          {
            id: "category",
            label: "SETTINGS_NEWS.ITEMS.ARTICLE_CATEGORY",
            routerLink: NewsSettingRoutePaths.category,
            permissions: COMMON_GUARD_OPTIONS.ARTICLE_CATEGORY.VIEW.permissions,
          },
        ],
      },
    ]);
  },
});
